import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { frontendRoutes } from '../../../Constants/constants';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo } from 'react';
import { addStaticToken, getBuilderId } from "../../../redux/action/action";
import Footer from '../../Footer/Footer';
import { Button } from '../../Button/Button';
import { useContentSettings } from '../../../hooks/useContentSettings';
import { useTranslation } from 'react-i18next';
import Header from '../../Header/Header';
import Swal from 'sweetalert2';

type StepCardProp = {
    index: number
    title: string
    detail: string
}

const StepCard = ({ index, title, detail }: StepCardProp) => {
    return (
        <div className='card-body'>
            <div className='card-heading d-flex align-items-center gap-3'>
                <Button style={{ boxShadow: '2px 6px 20px 2px rgba(0, 0, 0, 0.32)' }} className='button'>{index + 1}</Button>
                <h1 className='heading'>{title}</h1>
            </div>
            <p className='description'>{detail}</p>
        </div>
    )
}

const HomePage = () => {

    const params = useParams<{ builder_name: string }>();
    const history = useHistory();
    const dispatch = useDispatch()
    const { t } = useTranslation();

    const builderId = useSelector((state: any) => state.builder.builder_id);
    const tContent = useContentSettings();

    const isDRHorton = params?.builder_name?.toLowerCase().includes('drhorton');

  const tourSteps = useMemo(() => {
        return [
            {
                title: tContent('step_1_title'),
                detail: tContent('step_1_description')
            },
            {
                title: tContent('step_2_title'),
                detail: tContent('step_2_description')
            },
            {
                title: tContent('step_3_title'),
                detail: tContent('step_3_description')
            },
            {
                title: tContent('step_4_title'),
                detail: tContent('step_4_description')
            },
        ]
    }, [tContent]);

    useEffect(() => {
        dispatch(addStaticToken());
    }, [dispatch])

    useEffect(() => {
        localStorage.setItem('builder_name', params.builder_name);

        !builderId && dispatch(getBuilderId());
      }, [dispatch, builderId, params.builder_name]);

    // useEffect(() => {
    //     builderError && history.push('/')
    // }, [builderError, history])


    const defaultDisclosureModal = () => {
        Swal.fire({
            title: 'Pre-Tour Disclosure',
            html: `NterNow provides self-guided tours in select D.R. Horton communities. NterNow and its vendor, Persona,
                    may collect and process your biometric data to verify your identity and your precise geolocation.
                    D.R. Horton will not collect or process your biometric information or your precise geolocation.
                    For information regarding how NterNow and its vendors handle your personal information including your
                    biometric data, please visit NterNow’s privacy policy at <a href="https://nternow.com/privacy-policy" target="_blank">
                    https://nternow.com/privacy-policy.</a> NterNow will share your name, email address, and phone number with D.R. 
                    Horton, which D.R. Horton may use to contact you regarding your interest in a D.R. Horton home. For 
                    information about our use of your personal information, please view our Privacy Policy at <a href="https://drhorton.com" target="_blank">
                     www.drhorton.com.</a> Home and community information are subject to change. Homes are subject to prior 
                     sale. D.R. Horton is an Equal Housing Opportunity Builder.`,
            showConfirmButton: false,
            showCloseButton: true,
        })
    };

    return (
        <>
            <section className="home-page-screen">
                <div className="container mt-md-3">
                    <Header />
                    <div className='banner'>
                        <h1>{tContent('self_tour_scheduling_title')}<br/>{tContent('self_tour_scheduling_subtitle')}</h1>
                        <p>{tContent('self_tour_scheduling_description')}</p>
                    </div>

                    <div className='cards-container'>
                        <h1 className='heading text-center'>{tContent('how_it_works_title')}</h1>
                        <p className='detail text-center mt-md-3 mt-2'></p>

                        <div className='cards-box'>
                            {tourSteps.map(({title, detail}, index) =>
                            <StepCard key={index} index={index} title={title} detail={detail} />
                            )}
                        </div>
                        <div className='tour-cta'>
                            <h4 className="text-center" >{t('ready_tour')}</h4>
                            <Button
                            style={{ boxShadow: '2px 6px 20px 2px rgba(0, 0, 0, 0.32)' }} className='button mx-auto d-block text-uppercase mb-4'
                            onClick={() => history.push(frontendRoutes.chooseTour(params.builder_name).path)}
                            >
                                {t('start_touring_button')}
                            </Button>

                        </div>
                        {isDRHorton && (
                            <div className="text-center mt-4">
                                Nternow provides self-guided tours in select D.R.Horton communities. For important information click
                                {' '}
                                <span
                                    className="fw-bold text-secondary pointer"
                                    onClick={defaultDisclosureModal}
                                >
                                    here.
                                </span>
                            </div>
                        )}
                    </div>
                </div>
                <Footer />
                <hr className='mb-0' />
                <div className='footer container d-flex align-items-center gap-3 py-1'>
                    <div className='d-flex align-items-center gap-3'>
                    <p className='m-0'><a href='https://nternow.com/privacy-policy/' target='_blank' rel='noopener noreferrer' className='text-secondary'>{t('privacy_policy')}</a></p>
                    <hr />
                    <p className='m-0'><a href='https://nternow.com/privacy-policy/' target='_blank' rel='noopener noreferrer' className='text-secondary'>{t('terms_legal')}</a></p>

                    </div>
                </div>
            </section>
        </>
    )
}

export default HomePage
